import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, SettingsOverviewDTOConverter, SelloutReleaseCategoryPreviewConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
export var SettingsOverviewDTOLayer =
/*#__PURE__*/
function () {
  function SettingsOverviewDTOLayer() {
    var _this = this;

    _classCallCheck(this, SettingsOverviewDTOLayer);

    this.convertDTO = function (response) {
      var settingsOverview = new Map();
      (response.data.result || []).map(function (item) {
        var settingsOverviewDTOs = _this.converter.toObject(item, jsonConversions);

        var settingsZonesOverviewDTOs = new Map();
        settingsOverviewDTOs.settingsZonesOverviewDTO.forEach(function (settingsOverviewDTO) {
          settingsZonesOverviewDTOs.set(settingsOverviewDTO.zoneId, settingsOverviewDTO);
        });
        settingsOverview.set(settingsOverviewDTOs.productCategoryId, {
          settingsZonesOverviewDTOs: settingsZonesOverviewDTOs,
          includedStats: {
            includedInRelease: settingsOverviewDTOs.includedInRelease,
            childrenStats: settingsOverviewDTOs.childrenStats,
            inPathToIncluded: settingsOverviewDTOs.inPathToIncluded
          },
          productCategoryId: settingsOverviewDTOs.productCategoryId
        });
      });
      return settingsOverview;
    };

    this.convertSelloutDTO = function (response) {
      var settingsOverview = new Map();
      (response.data.result || []).map(function (item) {
        var categoryPreviewDTO = _this.selloutCategoryPreviewConverter.toObject(item, jsonConversions);

        settingsOverview.set(categoryPreviewDTO.categoryId, {
          includedStats: {
            includedInRelease: categoryPreviewDTO.includedInRelease,
            childrenStats: categoryPreviewDTO.childrenStats,
            inPathToIncluded: categoryPreviewDTO.inPathToIncluded,
            itemCount: categoryPreviewDTO.itemsCount,
            productsCount: categoryPreviewDTO.productsCount,
            sitesCount: categoryPreviewDTO.sitesCount
          },
          productCategoryId: categoryPreviewDTO.categoryId
        });
      });
      return settingsOverview;
    };
  }
  /**
   * Gets general settings overview data
   */


  _createClass(SettingsOverviewDTOLayer, [{
    key: "getOverview",
    value: function getOverview(releaseId) {
      var _this2 = this;

      return releaseId ? api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.RELEASES, "/").concat(releaseId).concat(CONSTANTS.API.ENDPOINTS.SETTINGS_OVERVIEW)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.convertDTO(response);
      }) : api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_OVERVIEW)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.convertDTO(response);
      });
    }
  }, {
    key: "includeCategoriesToRelease",
    value: function includeCategoriesToRelease(releaseId, productCategoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.RELEASES, "/").concat(releaseId).concat(CONSTANTS.API.ENDPOINTS.INCLUDE_CATEGORIES)).post({
                  productCategoryIds: productCategoryIds
                }, {
                  responseType: 'json'
                });

              case 3:
                response = _context.sent;
                return _context.abrupt("return", this.convertDTO(response));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                logger.error(_context.t0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));
    }
  }, {
    key: "excludeCategoriesToRelease",
    value: function excludeCategoriesToRelease(releaseId, productCategoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.RELEASES, "/").concat(releaseId).concat(CONSTANTS.API.ENDPOINTS.EXCLUDE_CATEGORIES)).post({
                  productCategoryIds: productCategoryIds
                }, {
                  responseType: 'json'
                });

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", this.convertDTO(response));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                logger.error(_context2.t0);
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));
    }
    /**
     * Gets general settings overview data
     */

  }, {
    key: "getSelloutOverview",
    value: function getSelloutOverview(releaseId, itemFilterHash) {
      var _this3 = this;

      return releaseId && itemFilterHash ? api(CONSTANTS.API.ENDPOINTS.SELLOUT_RELEASE_CATEGORY_PREVIEWS(releaseId, itemFilterHash)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this3.convertSelloutDTO(response);
      }) : api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_OVERVIEW)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this3.convertDTO(response);
      });
    }
  }, {
    key: "includeCategoriesToSelloutRelease",
    value: function includeCategoriesToSelloutRelease(releaseId, productCategoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.SELLOUT_RELEASE_CATEGORY_PREVIEWS_INCLUSION(releaseId)).post({
                  categoryIds: productCategoryIds
                }, {
                  responseType: 'json'
                });

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", this.convertSelloutDTO(response));

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                logger.error(_context3.t0);
                return _context3.abrupt("return", Promise.reject(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));
    }
  }, {
    key: "excludeCategoriesToSelloutRelease",
    value: function excludeCategoriesToSelloutRelease(releaseId, productCategoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.SELLOUT_RELEASE_CATEGORY_PREVIEWS_EXCLUSION(releaseId)).post({
                  categoryIds: productCategoryIds
                }, {
                  responseType: 'json'
                });

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", this.convertSelloutDTO(response));

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                logger.error(_context4.t0);
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));
    }
  }, {
    key: "calculateSelloutReleasePreview",
    value: function calculateSelloutReleasePreview(releaseId, itemFilter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.SELLOUT_RELEASE_CATEGORY_PREVIEWS_CALCULATION(releaseId)).post({
                  itemFilter: itemFilter
                }, {
                  responseType: 'json'
                });

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", response.data.result);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                logger.error(_context5.t0);
                return _context5.abrupt("return", Promise.reject(_context5.t0));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }));
    }
  }]);

  return SettingsOverviewDTOLayer;
}();

__decorate([Inject, __metadata("design:type", SettingsOverviewDTOConverter)], SettingsOverviewDTOLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", SelloutReleaseCategoryPreviewConverter)], SettingsOverviewDTOLayer.prototype, "selloutCategoryPreviewConverter", void 0);